import { fromJS } from 'immutable';
import { createStructuredSelector } from 'reselect';

import makeAction from 'utils/makeAction';


const SET_IMPERSONATE_USER = 'cam4/admin/SET_IMPERSONATE_USER';

const initialState = fromJS({ user: null });

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case SET_IMPERSONATE_USER:
      return state.set('user', fromJS(action.user));
    default:
      return state;
  }
}

export const NAME = 'impersonate';

// Selectors
const impersonateUser = (state) => state[NAME].get('user');
// Actions
const setImpersonateUserAction = makeAction(SET_IMPERSONATE_USER, 'user');

function resetImpersonateUser() {
  return (dispatch) => dispatch(setImpersonateUserAction(null));
}

function setImpersonateUser(user) {
  return (dispatch) => dispatch(setImpersonateUserAction(user));
}

export const selector = createStructuredSelector({ impersonateUser });

export const actionCreators = {
  resetImpersonateUser,
  setImpersonateUser,
};
